<div class="detail-container">
  <nb-card [nbSpinner]="!!(saving$|async)">
    <nb-card-header>
      <button nbButton ghost status="primary" (click)="navigateBack()">
        <nb-icon pack="eva" icon="arrow-back-outline"></nb-icon>
      </button>
      <h5>Prüfpunkt</h5>
      @if (canEdit() && !isNew()) {
        <wr-edit-delete-button-group (edit)="onEdit()" (delete)="onDelete()" [canDelete]="signal(false)"></wr-edit-delete-button-group>
      }
    </nb-card-header>
    <nb-card-body>
      @if (formWrapper.form(); as form) {
        <nb-tabset (changeTab)="onTabChange($event)">
          <nb-tab [tabId]="'general'" [active]="activeTabId() === 'general'" tabTitle="Allgemein">
            <wr-checkpoint-detail-form [formWrapper]="formWrapper" [currentTenantId]="catalogTenantId()"></wr-checkpoint-detail-form>
          </nb-tab>
          <nb-tab [tabId]="'presets'" [active]="activeTabId() === 'presets'" [tabTitle]="'Feststellungen (' + formWrapper.form().controls.assessmentPresets.length + ')'">
            <wr-assessment-detail-form [formWrapper]="formWrapper"
                                       [currentTenantId]="catalogTenantId()"
                                       [toDeleteAssessmentPreset]="toDeleteAssessmentPreset"
                                       [toDeleteTextBlocks]="toDeleteTextBlocks"
                                       [isEditing]="isEditing">
            </wr-assessment-detail-form>
          </nb-tab>
        </nb-tabset>
      }
    </nb-card-body>
    @if (canEdit()) {
      <nb-card-footer>
        <button size="medium" [disabled]="!isEditing" nbButton status="primary" (click)="submit()">Speichern</button>
        <button size="medium" [disabled]="!isEditing" nbButton status="basic" (click)="cancel()">Zurück</button>
      </nb-card-footer>
    }
  </nb-card>
</div>
